// extracted by mini-css-extract-plugin
module.exports = {"custom-alert":"_344cfb","alert__icon":"dba31c","alert__text":"_35c231","alert__button":"_1e63d9"};